import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

class DevJourney extends Component {
  render() {
    return (
      <React.Fragment>
        <Grid container style={{ backgroundColor: '#22292f', paddingBottom: '1rem', paddingTop: '1rem' }} justify="center">
          <Grid item xs={10}>
            <Typography variant="h3" style={{ textAlign: 'center', color: '#5dc8ae', paddingBottom: '1rem', paddingTop: '1rem' }}>
              dev.journey()
            </Typography>
            <Typography variant="h5" style={{ textAlign: 'center', color: '#fff', paddingBottom: '1rem', paddingTop: '1rem', fontWeight: '300' }}>
              <b style={{ fontWeight: '500' }}>Programa educacional</b> com 4 iniciativas que visa complementar a formação dos estudantes para que eles se tornem <b style={{ fontWeight: '500' }}>engenheiros de software</b> capazes de desenvolverem sistemas reais.
            </Typography>
            <Grid container spacing={32}>
              <Grid item xs={12} sm={6}>
                <div style={{ backgroundColor: '#fff', borderRadius: '.25rem', padding: '1rem', textAlign: 'center' }}>
                  <img src="./devlearn.png" alt="UCL Logo" style={{ height:'100px' }}/>
                  <Typography variant="h4" style={{ fontWeight: '500' }}>
                    dev.learn()
                  </Typography>
                  <Typography variant="h6" style={{ fontWeight: '300' }}>
                    <b style={{ fontWeight: '500' }}>Cursos sobre tecnologia</b> onde os participantes são apresentados a <b style={{ fontWeight: '500' }}>ferramentas e técnicas de desenvolvimento</b> introdutórias e avançadas.
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div style={{ backgroundColor: '#fff', borderRadius: '.25rem', padding: '1rem', textAlign: 'center' }}>
                  <img src="./devboost.png" alt="UCL Logo" style={{ height:'100px' }}/>
                  <Typography variant="h4" style={{ fontWeight: '500' }}>
                    dev.boost()
                  </Typography>
                  <Typography variant="h6" style={{ fontWeight: '300' }}>
                    <b style={{ fontWeight: '500' }}>Grupos de estudos</b> onde os participantes praticam  <b style={{ fontWeight: '500' }}>desenvolvimento de sistemas</b> em times com projetos de clientes externos ou da universidade.
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div style={{ backgroundColor: '#fff', borderRadius: '.25rem', padding: '1rem', textAlign: 'center' }}>
                  <img src="./devcamp.png" alt="UCL Logo" style={{ height:'100px' }}/>
                  <Typography variant="h4" style={{ fontWeight: '500' }}>
                    dev.camp()
                  </Typography>
                  <Typography variant="h6" style={{ fontWeight: '300' }}>
                    <b style={{ fontWeight: '500' }}>Escola de férias</b> onde os participantes trabalham num <b style={{ fontWeight: '500' }}>projeto multi-time</b> como o de uma empresa com arquitetura de software moderna.
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div style={{ backgroundColor: '#fff', borderRadius: '.25rem', padding: '1rem', textAlign: 'center' }}>
                  <img src="./devhack.png" alt="UCL Logo" style={{ height:'100px' }}/>
                  <Typography variant="h4" style={{ fontWeight: '500' }}>
                    dev.hack()
                  </Typography>
                  <Typography variant="h6" style={{ fontWeight: '300' }}>
                    <b style={{ fontWeight: '500' }}>Hackathos e Hackdays</b> onde os participantes são desafiados a buscar num tempo limitado <b style={{ fontWeight: '500' }}>soluções inovadoras</b> para projetos reais utilizando tecnologia.
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default DevJourney;